import { createUseStyles } from 'react-jss'

import { darkGrey } from '../../../../../../../../styles/const/colors'

const useStyles = createUseStyles({
  finalCampaignName: {
    color: darkGrey,
    fontFamily: 'Roboto Mono, sans-serif',
    fontSize: 14,
    cursor: 'text'
  }
})

export default useStyles
